var map = {
	"./1.svg": 110,
	"./10.svg": 111,
	"./2.svg": 112,
	"./3.svg": 113,
	"./4.svg": 114,
	"./5.svg": 115,
	"./6.svg": 116,
	"./7.svg": 117,
	"./8.svg": 118,
	"./9.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;